<template>
  <div class="w-100">
    <b-overlay spinner-variant="primary" :show="isLoading">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h1 class="m-0">Відділи і посади ({{ departments.length }})</h1>
        <b-button variant="primary" size="lg" @click="addPupUpShow = true">
          <feather-icon class="ml-0" icon="PlusIcon" size="20" /> Додати відділ
          чи посаду
        </b-button>
      </div>
      <div class="mb-1 d-flex align-items-center">
        <b-form-select class="w-25 mr-1" v-model="selected_group">
          <b-form-select-option value="all"> Всі </b-form-select-option>
          <b-form-select-option value="departments">
            Відділи
          </b-form-select-option>
          <b-form-select-option value="positions">
            Посади
          </b-form-select-option>
        </b-form-select>
        <b-form-input
          v-model="filterQuery"
          placeholder="Фільтрувати за назвою"
        />
      </div>
      <div class="row mb-1">
        <div class="col-12">
          <small>
            Результатів: <strong>{{ totalResults }}</strong>
          </small>
        </div>
      </div>

      <div
        v-for="group in groupedDepartments"
        :key="group.department ? group.department.id : 'other'"
        class="department-group"
      >
        <router-link
          v-if="group.showDepartment"
          class="d-block"
          :to="{
            name: 'departments-single',
            params: { id: group.department.id },
          }"
        >
          <b-card>
            <div class="d-flex align-items-center justify-content-start">
              <feather-icon
                icon="ArchiveIcon"
                size="24"
                class="mr-2 flex-shrink-0"
              />
              <h4 class="m-0" v-html="highlight(group.department.name)"></h4>
            </div>
          </b-card>
        </router-link>
        <div
          v-else-if="group.department && group.positions.length"
          class="department-header-plain d-flex align-items-center"
        >
          <feather-icon
            icon="ArchiveIcon"
            size="20"
            class="mr-1 flex-shrink-0"
          />
          <span>{{ group.department.name }}</span>
        </div>
        <div
          v-else-if="!group.department && group.positions.length"
          class="department-header-plain"
        >
          Інші посади
        </div>
        <div class="row positions-row" v-if="group.positions.length">
          <router-link
            v-for="p in group.positions"
            :key="p.uid"
            class="d-block col-12"
            :to="{
              name: 'departments-single',
              params: { id: p.id },
            }"
          >
            <b-card class="position-card">
              <div class="d-flex align-items-center justify-content-start">
                <feather-icon
                  icon="UserIcon"
                  size="24"
                  class="mr-2 flex-shrink-0"
                />
                <div>
                  <h4 class="m-0" v-html="highlight(p.name)"></h4>
                  <small class="text-muted" v-if="p.current_worker_name">
                    {{ p.current_worker_name }}
                  </small>
                </div>
              </div>
            </b-card>
          </router-link>
        </div>
      </div>

      <b-alert
        v-if="!totalResults && !isLoading"
        show
        variant="light"
        class="text-center"
      >
        Нічого не знайдено
      </b-alert>
    </b-overlay>
    <b-modal
      v-model="addPupUpShow"
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-overlay :show="addingLoading">
        <h2 class="mb-2 mt-2">
          <feather-icon icon="PlusIcon" size="24" /> Додавання нового відділу
        </h2>
        <div class="form-group">
          <label>Назва</label>
          <b-form-input class="mb-2" v-model.trim="new_department.name" />
          <b-form-checkbox v-model="new_department.is_position">
            Є посадою
          </b-form-checkbox>
        </div>
        <div class="form-group">
          <label for=""> Предок </label>
          <v-select
            id="department-parent"
            v-model="selectedParent"
            :options="parentDepartments"
            label="text"
            placeholder="Оберіть основний відділ-предок (необов'язково)"
          />
        </div>
        <b-alert variant="danger p-1" :show="!!nameExists">
          Відділ з таким ім'ям вже існує
        </b-alert>
        <div class="form-group">
          <b-button
            :disabled="!!nameExists || !new_department.name"
            block
            variant="primary"
            size="lg"
            @click="createDepartment"
          >
            <span v-if="new_department.is_position">Додати посаду</span>
            <span v-else>Додати відділ</span>
          </b-button>
          <b-button
            block
            variant="outline-danger"
            size="lg"
            @click="addPupUpShow = false"
          >
            Скасувати
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      filterQuery: "",
      addingLoading: false,
      isLoading: false,
      departments: [],
      addPupUpShow: false,
      selectedParent: null,
      selected_group: "all",
      new_department: {
        name: "",
        id: null,
        parent: null,
      },
    };
  },
  computed: {
    groupedDepartments() {
      var query = this.filterQuery.toLowerCase();
      var showDepts = this.selected_group !== "positions";
      var showPositions = this.selected_group !== "departments";

      var allDepts = this.departments.filter(function (d) {
        return !d.is_position;
      });
      var allPositions = this.departments.filter(function (d) {
        return d.is_position;
      });

      var groups = [];
      var usedPositionIds = {};

      for (var i = 0; i < allDepts.length; i++) {
        var dept = allDepts[i];
        var deptMatch =
          !query.length || dept.name.toLowerCase().indexOf(query) > -1;

        var children = [];
        if (showPositions) {
          children = allPositions.filter(function (p) {
            return p.parent === dept.id;
          });
          if (query.length) {
            children = children.filter(function (p) {
              return p.name.toLowerCase().indexOf(query) > -1;
            });
          }
        }
        children.forEach(function (p) {
          usedPositionIds[p.id] = true;
        });

        if ((showDepts && deptMatch) || children.length) {
          groups.push({
            department: dept,
            showDepartment: showDepts && deptMatch,
            positions: children,
          });
        }
      }

      if (showPositions) {
        var orphans = allPositions.filter(function (p) {
          return !usedPositionIds[p.id];
        });
        if (query.length) {
          orphans = orphans.filter(function (p) {
            return p.name.toLowerCase().indexOf(query) > -1;
          });
        }
        if (orphans.length) {
          groups.push({
            department: null,
            showDepartment: false,
            positions: orphans,
          });
        }
      }

      return groups;
    },
    totalResults() {
      var count = 0;
      for (var i = 0; i < this.groupedDepartments.length; i++) {
        var g = this.groupedDepartments[i];
        if (g.showDepartment) count++;
        count += g.positions.length;
      }
      return count;
    },
    nameExists() {
      var exists = false;
      exists = this.departments.find(
        (element) => element.name == this.new_department.name
      );

      return exists;
    },
    parentDepartments() {
      var list = this.departments.map((e) => {
        return { text: e.name, value: e.id };
      });
      return list;
    },
  },
  methods: {
    async getDepartments() {
      this.isLoading = true;
      var response = await this.$api.get("/admin/departments");
      this.departments = response.data.data;
      this.isLoading = false;
    },
    highlight(value) {
      var value = value.toString();
      var term = this.filterQuery.toString();
      if (term.length > 1) {
        var reg = new RegExp(term, "gi");
        value = value.replace(reg, function (str) {
          return '<strong class="search-excerpt">' + str + "</strong>";
        });
        return value;
      } else {
        return value;
      }
    },
    async createDepartment() {
      this.addingLoading = true;
      try {
        var payload = {
          name: this.new_department.name,
          is_position: this.new_department.is_position || false,
          parent: this.selectedParent ? this.selectedParent.value : null,
        };
        var result = await this.$api.post("/admin/departments/create", payload);
        if (result.data.success) {
          this.$toast.success("Відділ створено");
          this.addPupUpShow = false;
          this.new_department = {
            name: "",
            id: null,
            parent: null,
          };
        }
      } catch (e) {
        this.$toast.error("Помилка при створенні відділу");
      }
      this.addingLoading = false;
      this.getDepartments();
    },
  },
  mounted() {
    this.getDepartments();
  },
};
</script>

<style lang="scss">
@import "~@core/scss/vue/libs/vue-select.scss";
.search-excerpt {
  background: yellow;
}
.position-card {
  background-color: #f0f7ff;
}
.department-group {
  margin-bottom: 0.25rem;
}
.department-header-plain {
  font-size: 1.1rem;
  font-weight: 600;
  padding: 0.5rem 0;
  color: #888;
}
.positions-row {
  margin-left: 1.5rem;
  border-left: 2px solid #e0e0e0;
  padding-left: 1rem;
  position: relative;
}
.positions-row > a {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    left: -1rem;
    top: 50%;
    width: 1rem;
    height: 0;
    border-top: 2px solid #e0e0e0;
  }
}
</style>
